import { render } from "./userDefinedFieldsViewer.vue?vue&type=template&id=847977aa&scoped=true"
import script from "./userDefinedFieldsViewer.vue?vue&type=script&lang=js"
export * from "./userDefinedFieldsViewer.vue?vue&type=script&lang=js"

import "./userDefinedFieldsViewer.vue?vue&type=style&index=0&id=847977aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847977aa"]])

export default __exports__